module.exports = __webpack_public_path__ + "img/开场·屏幕里的公主.3f5f5ba9.png";